import { defineMessages } from 'react-intl'

export default defineMessages({
  category: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.Category',
    defaultMessage: 'Category'
  },
  addContent: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.AddContent',
    defaultMessage: 'Add content...'
  },
  addTitle: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.AddTitle',
    defaultMessage: 'Add a title...'
  },
  responseCode: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.responseCode',
    defaultMessage: 'Response Code:'
  },
  isHiddenBeforeRelativeToUserTimezone: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.isHiddenBeforeRelativeToUserTimezone',
    defaultMessage: 'relative to user timezone'
  },
  responseBody: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.responseBody',
    defaultMessage: 'Response Body:'
  },
  output: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.output',
    defaultMessage: 'Output:'
  },
  buildError: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.buildError',
    defaultMessage: 'Build Error:'
  },
  input: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.input',
    defaultMessage: 'Input:'
  },
  stepNumber: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.stepNumber',
    defaultMessage: `Step {index}`
  },
  seconds: {
    id: 'FeaturesHistoryPage.BackToFeature',
    defaultMessage: `seconds`
  },
  duration: {
    id: 'FeaturesHistoryPage.Duration',
    defaultMessage: `Duration:`
  },
  recallNotification: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.recallNotification',
    defaultMessage: 'Recall'
  },
  unknownStatus: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.unknownStatus',
    defaultMessage: 'Unknown'
  },
  viewAnalytics: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.viewAnalytics',
    defaultMessage: 'View Analytics'
  },
  buildStepFailed: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.buildStepFailed',
    defaultMessage:
      'Something went wrong! There was an issue with building the {stepType} step. Please update your feature or reach out to Workgrid support for assistance.'
  },
  workgridSupport: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.workgridSupport',
    defaultMessage: 'Workgrid Support'
  },
  audienceMetaData: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.audienceMetaData',
    defaultMessage: 'Audience:'
  },
  sendOnMetaData: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.sendOnMetaData',
    defaultMessage: 'Send On:'
  },
  notificationSummary: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.notificationSummary',
    defaultMessage: 'Notification Summary'
  },
  notificationDetail: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.notificationDetail',
    defaultMessage: 'Notification Detail'
  },
  expandJSON: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.expandJSON',
    defaultMessage: 'View Full Response'
  },
  truncatedJSONMessage: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.truncatedJSONMessage',
    defaultMessage: 'Response has been truncated'
  },
  appUiNotificationSentMessage: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.appUiNotificationSentMessage',
    defaultMessage: 'Notification Sent'
  },
  viewLogs: {
    id: 'SpaceAppBuilderFeaturesPage.executeFeature.viewLogs',
    defaultMessage: 'View Feature Execution Logs'
  }
})
